module.exports = __webpack_public_path__ + "assets/RetinaNarr-MediumItalic.c9d644bf4a30571ca7736aca3f99d570.woff2";